import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/contact/feedback/page.tsx");
